<div>
  <h4>
    {{ 'Doc::PaymentHistory' | abpLocalization }}
  </h4>
  <ag-grid-angular
    style="width: 100%"
    class="ag-theme-digiwall"
    domLayout="autoHeight"
    [defaultColDef]="defaultColDef"
    [gridOptions]="gridOptions"
    [columnDefs]="columnDefs"
    [treeData]="true"
    [getDataPath]="getDataPath"
    #grid
    [getRowClass]="getRowClass"
  >
  </ag-grid-angular>
</div>
